<div class="dataprocess-workflowplan d-flex align-items-center gap-2">

  <div class="text-muted dataprocess-workflowplan-label">
    {{ 'Workflowset' | translate }}
  </div>

  <div class="flex-grow-1 dataprocess-workflowplan-select">
    <dx-select-box
      class="dataprocess-workflowplan-control"
      [items]="workflows"
      displayExpr="name"
      valueExpr="id"
      [value]="selectedWorkflowId"
      [searchEnabled]="true"
      [showClearButton]="true"
      [disabled]="isReadOnly"
      [placeholder]="('Workflow auswählen' | translate)"
      (onValueChanged)="onWorkflowSelectionChanged($event)"
    ></dx-select-box>
  </div>

  <div class="dataprocess-workflowplan-actions d-flex align-items-center gap-1">

    <dx-button
      class="dataprocess-workflowplan-control"
      [disabled]="isReadOnly"
      stylingMode="outlined"
      type="default"
      text="{{ 'Workflow' | translate }}"
      icon="add"
      (onClick)="requestCreateWorkflow()"
    ></dx-button>

    <dx-button
      class="dataprocess-workflowplan-control"
      [disabled]="isReadOnly || !selectedWorkflowId"
      stylingMode="outlined"
      type="default"
      text="{{ 'Workflowitem' | translate }}"
      icon="plus"
      (onClick)="requestAddWorkflowItem()"
    ></dx-button>

    <dx-button
      class="dataprocess-workflowplan-icon"
      [disabled]="isReadOnly || !selectedWorkflowId"
      stylingMode="text"
      type="default"
      icon="edit"
      hint="{{ 'Workflow bearbeiten' | translate }}"
      (onClick)="requestEditWorkflow()"
    ></dx-button>

    <dx-button
      class="dataprocess-workflowplan-icon"
      [disabled]="isReadOnly || !selectedWorkflowId"
      stylingMode="text"
      type="default"
      icon="copy"
      hint="{{ 'Workflow duplizieren' | translate }}"
      (onClick)="requestDuplicateWorkflow()"
    ></dx-button>

    <dx-button
      class="dataprocess-workflowplan-icon"
      [disabled]="isReadOnly || !selectedWorkflowId"
      stylingMode="text"
      type="default"
      icon="trash"
      hint="{{ 'Workflow löschen' | translate }}"
      (onClick)="requestDeleteWorkflow()"
    ></dx-button>

  </div>

</div>
